module.exports = "/images/gb.svg?9936cc97ec3d68c0ed5d25fba06e99b6";